import { SVGProps } from 'react'

export const FullScreenExitIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="40" height="40" rx="20" fill="#00A4FF" />
    <g clipPath="url(#clip0_12346)">
      <path
        d="M15 15L12 12M25 15L28 12M15 25L12 28M25 25L28 28"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_12346">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(11 11)"
        />
      </clipPath>
    </defs>
  </svg>
)
